import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/seguridad",
    label: "Seguridad",
    isActive: true,
  },
];

function Seguridad() {
  return (
    <Page
      title="Seguridad"
      description="Administración de roles y grupos de usuarios."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Seguridad;
